// src/components/PainelAtalhosSite.tsx
import React from 'react';
import { Box, Button, useTheme } from '@mui/material';

type Atalho = {
  imagem: string;
  alt: string;
  link: string;
};

type PainelAtalhosSiteProps = {
  atalhos: Atalho[];
};

export const PainelAtalhosSite: React.FC<PainelAtalhosSiteProps> = ({ atalhos }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: { xs: '100%', md: 250 },
        display: 'flex',
        flexDirection: { xs: 'row', md: 'column' },
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        gap: 2,
        justifyContent: { xs: 'center', md: 'flex-start' },
        mb: { xs: 2, md: 0 }
      }}
    >
      {atalhos.map((atalho, index) => (
        <Button
          key={index}
          onClick={() => window.location.href = atalho.link}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: { xs: '45%', md: '100%' },
            p: 0,
            backgroundColor: 'transparent',
            '&:hover': { backgroundColor: theme.palette.action.hover }
          }}
        >
          <Box
            component="img"
            src={atalho.imagem}
            alt={atalho.alt}
            sx={{
              width: { xs: '100%', sm: '80%', md: '100%' },
              maxWidth: 250,
              borderRadius: 1
            }}
          />
        </Button>
      ))}
    </Box>
  );
};
